(function () {
  'use strict';

  // ---- CONFIG ---- //
  var AUTO_OPEN_DELAY = 3000;
  var LOCK_AFTER_MESSAGES = 3;
  var PRODUCT_URL = 'https://nutraclub.co/products/doctor-ai?variant=47847791263895';
  var LOGIN_URL = '/account/login';
  var SESSION_KEY = 'ndw_chat_history';
  var CLOSED_KEY = 'ndw_widget_closed';
  var API_URL = 'https://pay.nutraclub.co/api/chat';

  // ---- STATE ---- //
  var messageCount = 0;
  var isOpen = false;
  var isLocked = false;
  var lockType = null; // 'login' | 'buy' | null
  var chatHistory = []; // [{text, sender}]
  var conversationMessages = []; // OpenAI format [{role, content}]

  // ---- AUTH HELPERS ---- //
  function getCustomerData() {
    var data = window.__ndw || {};
    return {
      isLoggedIn: data.customer === true,
      ordersCount: parseInt(data.orders_count, 10) || 0
    };
  }

  function determineLockType() {
    var customer = getCustomerData();
    if (!customer.isLoggedIn) return 'login';
    if (customer.ordersCount === 0) return 'buy';
    return null;
  }

  // ---- LOCAL STORAGE (shared across tabs, 24h TTL) ---- //
  var SESSION_TTL = 24 * 60 * 60 * 1000; // 24 hours

  function saveSession() {
    try {
      var data = {
        messages: chatHistory,
        messageCount: messageCount,
        isLocked: isLocked,
        lockType: lockType,
        conversationMessages: conversationMessages,
        timestamp: Date.now()
      };
      localStorage.setItem(SESSION_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function loadSession() {
    try {
      var raw = localStorage.getItem(SESSION_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (data.timestamp && (Date.now() - data.timestamp > SESSION_TTL)) {
        localStorage.removeItem(SESSION_KEY);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function clearSession() {
    try {
      localStorage.removeItem(SESSION_KEY);
    } catch (e) {}
  }

  function setWidgetClosed(closed) {
    try {
      if (closed) {
        localStorage.setItem(CLOSED_KEY, '1');
      } else {
        localStorage.removeItem(CLOSED_KEY);
      }
    } catch (e) {}
  }

  function wasWidgetClosed() {
    try {
      return localStorage.getItem(CLOSED_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  // ---- INJECT STYLES ---- //
  var css = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display&family=Outfit:wght@300;400;500;600;700&display=swap');

    #ndw-widget *,
    #ndw-widget *::before,
    #ndw-widget *::after {
      box-sizing: border-box;
      margin: 0;
    }

    #ndw-widget {
      font-family: 'Outfit', system-ui, sans-serif;
      font-size: 14px;
      line-height: 1.6;
      position: fixed;
      bottom: 24px;
      right: 24px;
      z-index: 99999;
    }

    /* FAB Button */
    .ndw-fab {
      width: 62px;
      height: 62px;
      border-radius: 50%;
      background: linear-gradient(135deg, #4a9a3f, #3a7d31);
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 20px rgba(74, 154, 63, 0.35);
      transition: transform 0.22s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.22s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
    }

    .ndw-fab:hover {
      transform: scale(1.08);
      box-shadow: 0 8px 28px rgba(74, 154, 63, 0.45);
    }

    .ndw-fab svg {
      width: 28px;
      height: 28px;
      fill: none;
      stroke: #fff;
      stroke-width: 1.8;
    }

    .ndw-fab-badge {
      position: absolute;
      top: -2px;
      right: -2px;
      width: 18px;
      height: 18px;
      background: #f5a623;
      border-radius: 50%;
      border: 2px solid #fff;
      display: none;
      align-items: center;
      justify-content: center;
      font-size: 10px;
      font-weight: 700;
      color: #fff;
    }

    .ndw-fab-badge.ndw-visible {
      display: flex;
    }

    /* Chat Window */
    .ndw-chat {
      position: absolute;
      bottom: 76px;
      right: 0;
      width: 350px;
      height: 460px;
      background: #f5f7f2;
      border-radius: 20px;
      box-shadow: 0 20px 60px rgba(30, 50, 28, 0.14), 0 2px 8px rgba(30, 50, 28, 0.06);
      display: none;
      flex-direction: column;
      overflow: hidden;
      border: 1px solid rgba(74, 154, 63, 0.08);
      animation: ndw-slideUp 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .ndw-chat.ndw-open {
      display: flex;
    }

    @keyframes ndw-slideUp {
      from {
        opacity: 0;
        transform: translateY(12px) scaleY(0.96);
      }
      to {
        opacity: 1;
        transform: translateY(0) scaleY(1);
      }
    }

    /* Chat Header */
    .ndw-header {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 16px 18px;
      background: linear-gradient(135deg, #4a9a3f, #3a7d31);
      color: #fff;
    }

    .ndw-avatar {
      width: 40px;
      height: 40px;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.18);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .ndw-avatar svg {
      width: 22px;
      height: 22px;
      fill: none;
      stroke: #fff;
      stroke-width: 2;
    }

    .ndw-header-info {
      flex: 1;
    }

    .ndw-header-title {
      font-family: 'DM Serif Display', Georgia, serif;
      font-size: 17px;
      font-weight: 400;
      letter-spacing: -0.3px;
    }

    .ndw-header-status {
      font-size: 11px;
      font-weight: 500;
      opacity: 0.85;
    }

    .ndw-close {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      border: none;
      background: rgba(255, 255, 255, 0.15);
      color: #fff;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      line-height: 1;
      transition: background 0.22s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .ndw-close:hover {
      background: rgba(255, 255, 255, 0.3);
    }

    /* Messages */
    .ndw-messages {
      flex: 1;
      overflow-y: auto;
      padding: 18px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      background: #f5f7f2;
    }

    .ndw-messages::-webkit-scrollbar { width: 4px; }
    .ndw-messages::-webkit-scrollbar-track { background: transparent; }
    .ndw-messages::-webkit-scrollbar-thumb { background: #e4efe0; border-radius: 4px; }

    .ndw-msg {
      max-width: 85%;
      padding: 10px 14px;
      border-radius: 14px;
      font-size: 14px;
      line-height: 1.55;
      word-wrap: break-word;
      animation: ndw-msgIn 0.25s ease;
    }

    @keyframes ndw-msgIn {
      from { opacity: 0; transform: translateY(6px); }
      to { opacity: 1; transform: translateY(0); }
    }

    .ndw-msg--ai {
      align-self: flex-start;
      background: #ffffff;
      color: #1a2118;
      border-bottom-left-radius: 4px;
      box-shadow: 0 2px 8px rgba(30, 50, 28, 0.06);
    }

    .ndw-msg--ai a {
      color: #4a9a3f;
      font-weight: 600;
      text-decoration: underline;
    }

    .ndw-msg--user {
      align-self: flex-end;
      background: #4a9a3f;
      color: #fff;
      border-bottom-right-radius: 4px;
    }

    .ndw-msg--typing {
      align-self: flex-start;
      background: #ffffff;
      color: #8a9887;
      border-bottom-left-radius: 4px;
      box-shadow: 0 2px 8px rgba(30, 50, 28, 0.06);
      font-style: italic;
    }

    .ndw-msg--cta {
      align-self: flex-start;
      background: #ffffff;
      color: #1a2118;
      border-bottom-left-radius: 4px;
      box-shadow: 0 2px 8px rgba(30, 50, 28, 0.06);
      max-width: 90%;
    }

    .ndw-msg--cta p {
      margin-bottom: 10px;
      font-size: 14px;
      line-height: 1.55;
    }

    .ndw-cta-btn {
      display: inline-block;
      padding: 10px 20px;
      background: linear-gradient(135deg, #4a9a3f, #3a7d31);
      color: #fff;
      font-family: 'Outfit', system-ui, sans-serif;
      font-size: 14px;
      font-weight: 600;
      border: none;
      border-radius: 12px;
      text-decoration: none;
      cursor: pointer;
      transition: transform 0.22s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.22s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 4px 16px rgba(74, 154, 63, 0.25);
    }

    .ndw-cta-btn:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 20px rgba(74, 154, 63, 0.35);
    }

    /* Locked state */
    .ndw-locked {
      display: none;
      padding: 14px 18px;
      background: #ffffff;
      border-top: 1px solid #e4efe0;
      text-align: center;
    }

    .ndw-locked.ndw-visible {
      display: block;
    }

    .ndw-locked p {
      font-size: 13px;
      color: #8a9887;
      margin-bottom: 8px;
      line-height: 1.5;
    }

    .ndw-locked a {
      display: inline-block;
      padding: 8px 16px;
      background: linear-gradient(135deg, #4a9a3f, #3a7d31);
      color: #fff;
      font-family: 'Outfit', system-ui, sans-serif;
      font-size: 13px;
      font-weight: 600;
      border-radius: 10px;
      text-decoration: none;
      transition: transform 0.22s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .ndw-locked a:hover {
      transform: translateY(-1px);
    }

    .ndw-input-row.ndw-disabled {
      opacity: 0.4;
      pointer-events: none;
    }

    /* Input */
    .ndw-input-row {
      display: flex;
      gap: 8px;
      padding: 12px 14px;
      border-top: 1px solid #e4efe0;
      background: #ffffff;
    }

    .ndw-input {
      flex: 1;
      border: 1.5px solid #e4efe0;
      border-radius: 12px;
      padding: 10px 14px;
      font-size: 14px;
      font-family: 'Outfit', system-ui, sans-serif;
      color: #1a2118;
      background: #f5f7f2;
      outline: none;
      transition: border-color 0.22s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .ndw-input:focus {
      border-color: #4a9a3f;
    }

    .ndw-send {
      width: 40px;
      height: 40px;
      border-radius: 12px;
      border: none;
      background: #4a9a3f;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.22s cubic-bezier(0.4, 0, 0.2, 1), transform 0.22s cubic-bezier(0.4, 0, 0.2, 1);
      flex-shrink: 0;
    }

    .ndw-send:hover {
      background: #3a7d31;
      transform: scale(1.05);
    }

    .ndw-send svg {
      width: 16px;
      height: 16px;
      fill: none;
      stroke: #fff;
      stroke-width: 2;
    }

    /* Disclaimer */
    .ndw-disclaimer {
      padding: 8px 14px 10px;
      font-size: 11px;
      color: #8a9887;
      text-align: center;
      background: #ffffff;
    }

    /* Responsive */
    @media (max-width: 480px) {
      #ndw-widget {
        bottom: 16px;
        right: 12px;
        left: 12px;
      }
      .ndw-chat {
        width: calc(100vw - 24px);
        right: 0;
        height: 400px;
      }
    }
  `;

  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  // ---- CREATE DOM ---- //
  var widget = document.createElement('div');
  widget.id = 'ndw-widget';
  widget.innerHTML = `
    <div class="ndw-chat" id="ndw-chat">
      <div class="ndw-header">
        <div class="ndw-avatar">
          <svg viewBox="0 0 24 24"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
        </div>
        <div class="ndw-header-info">
          <div class="ndw-header-title">AI Doctor</div>
          <div class="ndw-header-status">\u25cf Online</div>
        </div>
        <button class="ndw-close" id="ndw-close">\u00d7</button>
      </div>
      <div class="ndw-messages" id="ndw-messages"></div>
      <div class="ndw-input-row" id="ndw-input-row">
        <input type="text" class="ndw-input" id="ndw-input" placeholder="Describe your question..." />
        <button class="ndw-send" id="ndw-send">
          <svg viewBox="0 0 24 24"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
        </button>
      </div>
      <div class="ndw-locked" id="ndw-locked"></div>
      <div class="ndw-disclaimer">\u26a0 Does not replace a doctor\u2019s consultation</div>
    </div>
    <button class="ndw-fab" id="ndw-fab">
      <svg viewBox="0 0 24 24"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
      <span class="ndw-fab-badge" id="ndw-badge">1</span>
    </button>
  `;
  document.body.appendChild(widget);

  // ---- REFERENCES ---- //
  var chatEl = document.getElementById('ndw-chat');
  var messagesEl = document.getElementById('ndw-messages');
  var inputEl = document.getElementById('ndw-input');
  var fabEl = document.getElementById('ndw-fab');
  var closeEl = document.getElementById('ndw-close');
  var sendEl = document.getElementById('ndw-send');
  var badgeEl = document.getElementById('ndw-badge');
  var inputRowEl = document.getElementById('ndw-input-row');
  var lockedEl = document.getElementById('ndw-locked');

  // ---- CHAT LOGIC ---- //
  function openWidget() {
    isOpen = true;
    chatEl.classList.add('ndw-open');
    badgeEl.classList.remove('ndw-visible');
    setWidgetClosed(false);
    if (!isLocked) inputEl.focus();
  }

  function closeWidget() {
    isOpen = false;
    chatEl.classList.remove('ndw-open');
    setWidgetClosed(true);
  }

  function toggleWidget() {
    if (isOpen) {
      closeWidget();
    } else {
      openWidget();
    }
  }

  function formatAIMessage(text) {
    return text
      .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>')
      .replace(/\n/g, '<br>');
  }

  function appendMessage(text, sender, skipSave) {
    var msg = document.createElement('div');
    msg.className = 'ndw-msg ndw-msg--' + sender;

    if (sender === 'ai') {
      msg.innerHTML = formatAIMessage(text);
    } else {
      msg.textContent = text;
    }

    messagesEl.appendChild(msg);
    messagesEl.scrollTop = messagesEl.scrollHeight;

    chatHistory.push({ text: text, sender: sender });
    if (!skipSave) saveSession();
  }

  function appendCTA(type) {
    var msg = document.createElement('div');
    msg.className = 'ndw-msg ndw-msg--cta';

    if (type === 'login') {
      msg.innerHTML = '<p>To continue our consultation, please log in to your account.</p><a class="ndw-cta-btn" href="' + LOGIN_URL + '">Log In</a>';
    } else {
      msg.innerHTML = '<p>To unlock full consultation, please purchase the AI Doctor subscription.</p><a class="ndw-cta-btn" href="' + PRODUCT_URL + '" target="_blank">Buy Now</a>';
    }

    messagesEl.appendChild(msg);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function showTyping() {
    var el = document.createElement('div');
    el.className = 'ndw-msg ndw-msg--typing';
    el.id = 'ndw-typing';
    el.textContent = 'Typing\u2026';
    messagesEl.appendChild(el);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function removeTyping() {
    var el = document.getElementById('ndw-typing');
    if (el) el.remove();
  }

  function lockChat(type) {
    isLocked = true;
    lockType = type;
    inputRowEl.classList.add('ndw-disabled');

    if (type === 'login') {
      lockedEl.innerHTML = '<p>Log in to continue the consultation</p><a href="' + LOGIN_URL + '">Log In</a>';
    } else {
      lockedEl.innerHTML = '<p>Purchase a subscription to continue</p><a href="' + PRODUCT_URL + '" target="_blank">Buy Subscription</a>';
    }

    lockedEl.classList.add('ndw-visible');
    saveSession();
  }

  function unlockChat() {
    isLocked = false;
    lockType = null;
    inputRowEl.classList.remove('ndw-disabled');
    lockedEl.classList.remove('ndw-visible');
    lockedEl.innerHTML = '';
    saveSession();
  }

  function handleLockCheck() {
    var type = determineLockType();
    if (type === null) return;
    appendCTA(type);
    lockChat(type);
  }

  // ---- AI API CALL ---- //
  function sendToAI(userText) {
    conversationMessages.push({ role: 'user', content: userText });
    showTyping();

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: conversationMessages })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        removeTyping();
        if (data.reply) {
          conversationMessages.push({ role: 'assistant', content: data.reply });
          appendMessage(data.reply, 'ai');
        } else {
          appendMessage('Sorry, I encountered a temporary issue. Please try again.', 'ai');
        }
      })
      .catch(function () {
        removeTyping();
        appendMessage('Connection error. Please check your internet and try again.', 'ai');
      });
  }

  function sendMessage() {
    if (isLocked) return;
    var text = inputEl.value.trim();
    if (!text) return;

    appendMessage(text, 'user');
    inputEl.value = '';
    messageCount++;

    if (messageCount >= LOCK_AFTER_MESSAGES) {
      var lockNeeded = determineLockType();
      if (lockNeeded) {
        setTimeout(function () { handleLockCheck(); }, 600);
        return;
      }
    }

    sendToAI(text);
  }

  function sendGreeting() {
    var greeting = "Hello! I'm your AI Doctor. Describe your symptoms or health questions \u2014 I'll help you get oriented and suggest next steps.";
    if (!isOpen) {
      badgeEl.classList.add('ndw-visible');
    }
    appendMessage(greeting, 'ai');
    conversationMessages.push({ role: 'assistant', content: greeting });
  }

  // ---- RESTORE SESSION ---- //
  function restoreChat() {
    var session = loadSession();
    if (!session || !session.messages || session.messages.length === 0) {
      return false;
    }

    chatHistory = [];
    messageCount = session.messageCount || 0;
    conversationMessages = session.conversationMessages || [];

    session.messages.forEach(function (item) {
      var msg = document.createElement('div');
      msg.className = 'ndw-msg ndw-msg--' + item.sender;
      if (item.sender === 'ai') {
        msg.innerHTML = formatAIMessage(item.text);
      } else {
        msg.textContent = item.text;
      }
      msg.style.animation = 'none';
      messagesEl.appendChild(msg);
      chatHistory.push(item);
    });

    messagesEl.scrollTop = messagesEl.scrollHeight;

    if (session.isLocked && session.lockType) {
      var currentLockNeeded = determineLockType();

      if (session.lockType === 'login' && getCustomerData().isLoggedIn) {
        if (currentLockNeeded === 'buy') {
          appendCTA('buy');
          lockChat('buy');
        } else {
          unlockChat();
        }
      } else if (session.lockType === 'buy' && getCustomerData().ordersCount > 0) {
        unlockChat();
      } else {
        lockChat(session.lockType);
        appendCTA(session.lockType);
      }
    }

    return true;
  }

  // ---- EVENT LISTENERS ---- //
  fabEl.addEventListener('click', toggleWidget);
  closeEl.addEventListener('click', closeWidget);
  sendEl.addEventListener('click', sendMessage);
  inputEl.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') sendMessage();
  });

  // ---- INIT ---- //
  var hasHistory = restoreChat();
  var wasClosed = wasWidgetClosed();

  if (hasHistory) {
    if (!wasClosed) {
      setTimeout(function () { openWidget(); }, AUTO_OPEN_DELAY);
    }
  } else {
    if (!wasClosed) {
      setTimeout(function () {
        openWidget();
        sendGreeting();
      }, AUTO_OPEN_DELAY);
    } else {
      sendGreeting();
    }
  }

})();
